import { useState, useMemo, useCallback } from 'react';

/**
 * Hook pour le rendu progressif de listes longues.
 * Affiche les N premiers éléments puis permet d'en charger plus.
 * Réduit drastiquement le nombre de nœuds DOM sur les listes >50 éléments.
 *
 * @param {Array} items - Liste complète des éléments
 * @param {number} initialCount - Nombre d'éléments affichés initialement (défaut: 50)
 * @param {number} increment - Nombre d'éléments ajoutés à chaque "Voir plus" (défaut: 50)
 * @returns {{ visibleItems, hasMore, showMore, resetLimit, totalCount, visibleCount }}
 */
export default function useProgressiveList(items, initialCount = 50, increment = 50) {
  const [limit, setLimit] = useState(initialCount);

  const visibleItems = useMemo(() => items.slice(0, limit), [items, limit]);
  const hasMore = items.length > limit;
  const showMore = useCallback(() => setLimit(prev => prev + increment), [increment]);
  const resetLimit = useCallback(() => setLimit(initialCount), [initialCount]);

  return {
    visibleItems,
    hasMore,
    showMore,
    resetLimit,
    totalCount: items.length,
    visibleCount: visibleItems.length,
  };
}
